/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import XInput from "vux/src/components/x-input/index.vue"; // this line is trasformed by vux-loader
export default {
  components: {
    XInput: XInput
  },
  props: {
    title: {
      type: String,
      default: i18n.tc("95")
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: i18n.tc("490")
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      hasTitleSlot: false
    };
  },
  computed: {
    inDingding: function inDingding() {
      return navigator.userAgent.includes('DingTalk');
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      this.$emit('on-change', val);
      this.$emit('input', val);
    }
  },
  methods: {
    scan: function scan() {
      var _this = this;
      this.$DingTalk.biz.util.scan({
        type: 'all',
        tips: i18n.tc("491"),
        onSuccess: function onSuccess(_ref) {
          var text = _ref.text;
          _this.currValue = text;
        },
        onFail: function onFail(e) {
          _this.$vux.toast.text(i18n.tc("492"));
          console.log('scan error');
        }
      });
    }
  },
  mounted: function mounted() {
    this.$slots.title && (this.hasTitleSlot = true);
  }
};